import React from 'react';
export const Header = () => {
  return <header className="mb-6" data-id="element-113">
      <div style={{
      backgroundColor: '#465866'
    }} className="p-2 text-center text-lg font-medium text-white mb-4" data-id="element-114">
        ADVERTORIAL
      </div>
      <h1 className="text-5xl md:text-6xl font-bold text-gray-800 mb-4 leading-tight" data-id="element-115">
        Veterinarian Admits: "I Was Wrong About Anxiety Medication for Dogs"
        (What She Uses Instead Will Shock You)
      </h1>
      <div className="w-full h-[400px] mb-4 overflow-hidden" data-id="element-116">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/k5aHPzLs6yGQGfgq8ax8jZ/ChatGPT_Image_Jul_30%2C_2025%2C_06_03_26_PM.png" alt="Dr. Sarah Chen with her German Shepherd wearing a PawEase vest by the seaside" className="w-full h-full object-contain" data-id="element-117" />
      </div>
      <p style={{
      color: '#76a0b4'
    }} className="text-2xl font-medium italic mb-6" data-id="element-118">
        After 15 years of prescribing anxiety medications to thousands of dogs,
        Dr. Sarah Chen made a confession that shocked the veterinary
        community...
      </p>
    </header>;
};